//用户登陆信息
export const setUser = (state, { currentUser_name, user_token, user_id, user_mail, user_phone }) => {
  // 在这里把用户名和token保存起来
  localStorage.setItem("currentUser_name", currentUser_name);
  localStorage.setItem("currentUser_token", user_token);
  localStorage.setItem("currentUser_id", user_id);
  localStorage.setItem("currentUser_mail", user_mail);
  localStorage.setItem("currentUser_phone", user_phone);

  state.currentUser.UserName = currentUser_name;
  state.currentUser.UserToken = user_token;
  state.currentUser.UserId = user_id;
  state.currentUser.UserMail = user_mail;
  state.currentUser.UserPhone = user_phone;
}
export const setUserMail = (state, { userId, mail }) => {
  // 在这里把用户名和token保存起来
  localStorage.setItem("currentUser_id", userId);
  localStorage.setItem("currentUser_mail", mail);

  state.currentUser.UserMail = mail;
  state.currentUser.UserId = userId;
}
export const setUserPhone = (state, phone) => {
  localStorage.setItem("currentUser_phone", phone);
  state.currentUser.UserPhone = phone;
}

export const setOnlyUserEmail = (state, { mail }) => {
  // 在这里把用户名和token保存起来
  localStorage.setItem("currentUser_mail", mail);
  state.currentUser.UserMail = mail;

}

export const LoginOut = (state) => {
  // 在这里把用户名和token保存起来 localStorage.removeItem('key')
  localStorage.removeItem("currentUser_name");
  localStorage.removeItem("currentUser_token");
  state.currentUser.UserName = "";
  state.currentUser.UserToken = "";
  state.currentUser.UserId = "";
  state.currentUser.UserMail = "";
}
export const saveKeyword = (state, keywords) => {
  // 在这里把用户名和token保存起来 localStorage.removeItem('key')
  state.keywords = keywords;
}
export const saveKeywordTime = (state) => {
  // 在这里把用户名和token保存起来 localStorage.removeItem('key')
  state.keywordtime = new Date().getTime();
}



// 保存当前菜单栏的路径
export const savePath = (state, pathName) => {
  state.pathName = pathName;
};

// 保存当前点击的数据源
export const saveCurrDbSource = (state, currDbSource) => {
  state.currDbSource = currDbSource;
};

// 保存当前点击的元数据
export const saveCurrJobData = (state, currJobData) => {
  state.currJobData = null;
  state.currJobData = currJobData;
};

// 保存所有数据源
export const saveDbSource = (state, DbSource) => {
  state.DbSource = DbSource;
};

// 保存搜索后选择的那一条元数据
export const saveSelectJobMeta = (state, selectJobMeta) => {
  state.selectJobMeta = selectJobMeta;
};

// 保存搜索的那一类专题
export const saveSpecialSubject = (state, specialSubject) => {
  state.specialSubject = specialSubject;
  state.selectJobMeta = {};
};

// 保存复制的元数据（名称为空）
export const saveDuplicateJobMeta = (state, duplicateJobMeta) => {
  state.duplicateJobMeta = duplicateJobMeta;
};

// 保存查询商品的条件
export const saveGoodsWhere = (state, info) => {
  state.conditions = info;
};



// WEBPACK FOOTER //
// ./src/store/mutations.js